import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import FloatingContact from '../../../components/feature/FloatingContact';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const SpecialProjects = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <FloatingContact />

      {/* Hero Section */}
      <section className="pt-24 md:pt-32 pb-12 md:pb-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-20">
          <div className="max-w-4xl">
            <p className="text-mid-gray text-xs uppercase tracking-[0.3em] mb-4 font-sans">
              Hizmetler
            </p>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-dark-gray leading-tight mb-6">
              Özel Projeler
            </h1>
            <p className="font-sans text-base md:text-lg text-mid-gray leading-relaxed">
              Benzersiz ihtiyaçlara özel, yaratıcı ve özgün mimari çözümler
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12 md:py-16 lg:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-8 lg:px-20">
          <article className="prose prose-lg max-w-none">
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6 md:mb-8">
              Özel projeler, standart çözümlerin ötesine geçen, benzersiz ihtiyaçlara yanıt veren mimari çalışmalardır. Kültürel mekânlar, butik oteller, restoranlar, sanat galerileri ve özel kullanım amaçlı yapılar, her biri kendine özgü tasarım yaklaşımı gerektiren projelerdir. Bu tür çalışmalarda yaratıcılık, işlevsellik ve özgünlük bir araya gelir.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Konsept Geliştirme ve Yaratıcı Süreç
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Her özel proje, derinlemesine bir araştırma ve konsept geliştirme süreciyle başlar. Projenin amacı, hedef kitlesi, kültürel bağlamı ve işlevsel gereksinimleri detaylı olarak analiz edilir. Bu analiz, özgün bir tasarım dilinin oluşturulmasına zemin hazırlar.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Konsept tasarım aşamasında, farklı fikirler üretilir ve alternatif senaryolar değerlendirilir. Eskizler, maketler ve dijital görseller, tasarım fikirlerinin somutlaştırılmasını sağlar. Müşteri ile yapılan düzenli görüşmeler, projenin doğru yönde ilerlemesini garanti eder.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Kültürel ve Sanatsal Mekânlar
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Müzeler, galeriler ve kültür merkezleri gibi mekânlar, sanat eserlerinin ve kültürel etkinliklerin en iyi şekilde sergilenmesini sağlayacak şekilde tasarlanır. Aydınlatma, akustik, iklim kontrolü ve güvenlik sistemleri, hassas bir şekilde planlanır.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Sergileme alanlarında esneklik önemlidir. Modüler duvar sistemleri, ayarlanabilı aydınlatma ve değişken mekân konfigürasyonları, farklı sergi türlerine adaptasyonu kolaylaştırır. Ziyaretçi sirkülasyonu, eserlerin rahatça izlenmesini sağlayacak şekilde düzenlenir.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Butik Otel ve Konaklama Mekânları
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Butik oteller, standart otel zincirlerinden farklı olarak özgün bir karakter ve deneyim sunar. Her oda, kendine özgü bir tasarım diliyle şekillendirilir. Yerel malzemeler, el yapımı mobilyalar ve özel sanat eserleri, mekâna kimlik kazandırır.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Ortak alanlar, misafirlerin sosyalleşmesini ve rahatlamasını teşvik edecek şekilde tasarlanır. Lobi, restoran, bar ve bahçe alanları, otel deneyiminin önemli parçalarıdır. Aydınlatma, müzik ve koku gibi duyusal unsurlar, atmosferin yaratılmasında rol oynar.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Restoran ve Gastronomi Mekânları
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Restoran tasarımında mutfak konsepti ve yemek deneyimi, mekânsal organizasyonu belirler. Açık mutfak düzenleri, şefin çalışmasını görünür kılar ve yemek hazırlama sürecini deneyimin bir parçası haline getirir. Oturma düzeni, mahremiyet ve sosyal etkileşim arasında denge kurar.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Malzeme seçimi, restoranın karakterini yansıtır. Ahşap, mermer, bakır ve deri gibi doğal malzemeler, sıcak ve davetkar bir atmosfer yaratır. Aydınlatma tasarımı, yemek deneyimini zenginleştirir; loş ışık romantik bir ortam yaratırken, parlak aydınlatma canlı bir enerji verir.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Wellness ve Spa Mekânları
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Spa ve wellness merkezleri, dinlenme ve yenilenme odaklı mekânlardır. Tasarım, huzur ve sakinlik hissi yaratmayı hedefler. Su öğeleri, doğal malzemeler ve yumuşak aydınlatma, rahatlatıcı bir atmosfer oluşturur.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Tedavi odaları, mahremiyet ve konfor sağlayacak şekilde planlanır. Akustik yalıtım, iklim kontrolü ve ergonomik mobilyalar, kullanıcı deneyimini optimize eder. Bekleme alanları ve dinlenme salonları, tedavi öncesi ve sonrası rahatlamayı destekler.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Atölye ve Yaratıcı Çalışma Alanları
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Sanatçı atölyeleri, tasarım stüdyoları ve yaratıcı çalışma alanları, üretim süreçlerini destekleyecek şekilde tasarlanır. Bol doğal ışık, yüksek tavanlar ve esnek mekân organizasyonu, yaratıcılığı teşvik eder.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Depolama çözümleri, malzeme ve ekipman organizasyonunu kolaylaştırır. Çalışma masaları, sergileme alanları ve toplantı köşeleri, farklı çalışma modlarına yanıt verir. Endüstriyel malzemeler ve sade detaylar, fonksiyonel ve ilham verici bir ortam yaratır.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Tarihi Yapıların Restorasyonu ve Yeniden İşlevlendirme
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Tarihi binaların restorasyonu, koruma ve yenileme arasında hassas bir denge gerektirir. Özgün mimari değerler korunurken, modern kullanım gereksinimlerine yanıt verilir. Detaylı rölöve çalışmaları, yapının mevcut durumunu belgelendirirken, restitüsyon çalışmaları özgün halini ortaya çıkarır.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Yeniden işlevlendirme projelerinde, yapının yeni kullanımı, mimari karakterle uyumlu olmalıdır. Eski fabrikaların loft dairelere, tarihi konutların butik otellere dönüştürülmesi gibi projeler, geçmiş ve günümüz arasında köprü kurar. Modern müdahaleler, özgün yapıdan ayırt edilebilir olmalı ancak bütünlüğü bozmamalıdır.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Peyzaj ve Dış Mekân Tasarımı
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Özel projelerde peyzaj tasarımı, mimari ile bütünleşik olarak geliştirilir. Bahçeler, teraslar ve dış mekân oturma alanları, iç mekânın doğal uzantısı olarak tasarlanır. Bitki seçimi, iklim koşulları, bakım gereksinimleri ve estetik tercihler göz önünde bulundurulur.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Su öğeleri, havuzlar, çeşmeler ve göletler, peyzajın odak noktalarını oluşturur. Dış mekân aydınlatması, bahçenin gece kullanımını mümkün kılar ve dramatik etkiler yaratır. Yürüyüş yolları, oturma alanları ve gölgelik sistemleri, dış mekân konforunu artırır.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Özel Malzeme ve Detay Çözümleri
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Özel projelerde malzeme seçimi, projenin özgünlüğünü belirleyen önemli bir faktördür. Nadir doğal taşlar, özel üretim seramikler, el işçiliği ahşap kaplamalar ve tasarım mobilyalar, mekâna karakter kazandırır. Malzemelerin dokusu, rengi ve ışıkla etkileşimi, mekânsal deneyimi zenginleştirir.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Detay tasarımı, mimari kaliteyi belirleyen unsurdur. Kapı kolları, aydınlatma armatürleri, merdiven korkulukları ve mobilya tasarımı, genel konseptle uyumlu olarak geliştirilir. Özel üretim elemanlar, projenin benzersizliğini pekiştirir.
            </p>

            <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mt-12 mb-6">
              Proje Koordinasyonu ve Uygulama
            </h2>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Özel projeler, yüksek düzeyde koordinasyon ve detay yönetimi gerektirir. Mimari, iç mimari, peyzaj, mekanik, elektrik ve özel sistem projeleri, bütünleşik olarak geliştirilir. Düzenli koordinasyon toplantıları, tüm disiplinlerin uyumlu çalışmasını sağlar.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6">
              Uygulama aşamasında, özel üretim elemanların zamanında temini ve kalite kontrolü kritik öneme sahiptir. Şantiye denetimleri, detayların projeye uygun olarak uygulanmasını garanti eder. Teslim öncesi testler ve ayarlamalar, projenin kusursuz tamamlanmasını sağlar.
            </p>

            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mt-12">
              Özel projeler, mimarlık disiplininin tüm yaratıcı potansiyelini ortaya koyan çalışmalardır. Her proje, benzersiz bir hikâye anlatır ve kullanıcılarına unutulmaz deneyimler sunar. Özgünlük, kalite ve detay mükemmelliği, bu projelerin ortak paydalarıdır.
            </p>
          </article>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-20 bg-cream">
        <div className="max-w-4xl mx-auto px-6 md:px-8 lg:px-20 text-center">
          <h2 className="font-serif text-2xl md:text-3xl text-dark-gray mb-6">
            Özel Projeniz İçin Görüşelim
          </h2>
          <p className="font-sans text-sm md:text-base text-mid-gray mb-8 max-w-2xl mx-auto">
            Benzersiz fikirlerinizi birlikte hayata geçirelim
          </p>
          <Link
            to="/iletisim"
            className="inline-block border border-dark-gray text-dark-gray px-8 py-3 text-sm tracking-wide hover:bg-dark-gray hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            İletişime Geçin
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SpecialProjects;
